<div mat-dialog-title class="dialog-header">
  <button type="button" class="close-button" (click)="onNoClick()" aria-label="Close dialog">
    <mat-icon>close</mat-icon>
  </button>

  <h4>{{ data.title }}</h4>
</div>
<div mat-dialog-content>
  <mat-form-field>
    <input matInput [(ngModel)]="data.questionText" placeholder="Question Text">
  </mat-form-field>
  <mat-form-field *ngIf="!data.update">
    <mat-label>Question Type</mat-label>
    <mat-select [(ngModel)]="data.questionType">
      <mat-option value="Extracted Question-Multiple Choice">Extracted Question-Multiple Choice</mat-option>
      <mat-option value="Extracted Question-Short Answer">Extracted Question-Short Answer</mat-option>
    </mat-select>
  </mat-form-field>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Cancel</button>
  <button mat-button [mat-dialog-close]="data" cdkFocusInitial>
    {{ data.update ? 'Update' : 'Add' }}
  </button>
</div>
